/** Dark theme defaults for ApexCharts — merge with chart-specific options. */

export const darkChartTheme = {
  chart: {
    background: 'transparent',
    foreColor: '#94A3B8',
    toolbar: { show: false },
  },
  theme: { mode: 'dark' },
  grid: {
    borderColor: '#1E2130',
    strokeDashArray: 4,
  },
  xaxis: {
    axisBorder: { color: '#1E2130' },
    axisTicks: { color: '#1E2130' },
    labels: { style: { colors: '#64748B', fontSize: '12px' } },
  },
  yaxis: {
    labels: { style: { colors: '#64748B', fontSize: '12px' } },
  },
  tooltip: {
    theme: 'dark',
    style: { fontSize: '12px' },
  },
  colors: ['#7C3AED', '#0D9488', '#6366F1', '#F59E0B', '#EF4444'],
  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.4,
      opacityTo: 0.05,
      stops: [0, 100],
    },
  },
  stroke: { curve: 'smooth', width: 2 },
  markers: { size: 0, hover: { size: 4 } },
};

function isPlainObject(value) {
  return value != null && typeof value === 'object' && !Array.isArray(value);
}

/** Deep-merge chart options (overrides win on leaf values). */
export function mergeChartOptions(base, overrides) {
  if (!overrides) return { ...base };
  const out = { ...base };
  for (const key of Object.keys(overrides)) {
    const baseVal = out[key];
    const overrideVal = overrides[key];
    if (isPlainObject(baseVal) && isPlainObject(overrideVal)) {
      out[key] = mergeChartOptions(baseVal, overrideVal);
    } else {
      out[key] = overrideVal;
    }
  }
  return out;
}

/**
 * Base options for line/area charts (gradient fill).
 * @param {{ enableToolbar?: boolean, chartType?: 'area'|'line'|'bar'|'stack' }} [opts]
 */
export function getDarkLineAreaChartBase(opts: any = {}) {
  const { enableToolbar = false, chartType = 'area' } = opts;
  const isBar = chartType === 'bar';
  return mergeChartOptions(darkChartTheme, {
    chart: {
      fontFamily: 'inherit',
      toolbar: enableToolbar
        ? { show: true, tools: { zoom: true, zoomin: true, zoomout: true, pan: true, reset: true } }
        : { show: false },
    },
    ...(isBar
      ? {
          fill: { type: 'solid', opacity: 1 },
          stroke: { width: 2 },
        }
      : {}),
  });
}

/** Base for bar charts — solid fills, no gradient. */
export function getDarkBarChartBase(opts: any = {}) {
  return getDarkLineAreaChartBase({ ...opts, chartType: 'bar' });
}

/** Base for donut/pie — colors only, no gradient fill. */
export function getDarkDonutChartBase(opts: any = {}) {
  const { enableToolbar = false } = opts;
  return mergeChartOptions(darkChartTheme, {
    chart: {
      fontFamily: 'inherit',
      toolbar: enableToolbar ? { show: true } : { show: false },
    },
    fill: { type: 'solid', opacity: 1 },
    stroke: { width: 0 },
  });
}
